import { Injectable } from "@angular/core";
import { ApicallService } from "@core-services/apicall.service";
import { AssetScroll } from "@models/asset_scroll";
import { Tradable } from "@models/interfaces/tradable";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { PaginationService } from "../../shared/services/pagination.service";
import { CoreStoreFacade } from "@modules/+new/core/core-store/domain/+state/core-store.facade";

@Injectable()
export class AssetsScrollService extends PaginationService<Tradable> {
	public constructor(
		public apiCallService: ApicallService,
		protected tradableListService: TradableListService,
		protected readonly coreStoreFacade: CoreStoreFacade
	) {
		super(coreStoreFacade, apiCallService, "assets", "v3", Tradable);
	}

	public convertPaginationList(list: AssetScroll[]): Tradable[] {
		if (!list) {
			return [];
		}

		return list
			.map((a: AssetScroll) => this.tradableListService.list.find((t) => t.getId() === a.getId()))
			.filter((i) => !!i && !i.isIndexOnly());
	}

	// Hard reset in case of api-error during data-fetching
	public refetchList(filters: string[] = [""]): void {
		this.resetList();
		this.resetError();
		this.filterUpdate(filters, "");
	}
}
